import { Serializable } from '@admin/core/models/serializable';
import { TransactionActionResultType } from '@admin/billing/transactions/shared/models/TransactionActionResultType';

export class TransactionActionResult
  implements Serializable<TransactionActionResult>
{
  fromObject(object: any): TransactionActionResult {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public resultType: TransactionActionResultType;
  public isMulti: boolean;
  public errorMessages: { [index: number]: string };
  public displayMessage: string;
}
